<template>
  <div class="main">
   

    <h1>Авторизация</h1>

    <div class="field-form">
    
      <div class="field-wrapper">
        <input
          v-model="login"
          ref="inputLogin"
          type="text"
          placeholder="&nbsp;"
          spellcheck="false"
          autocomplete="off"
        />
        <label>Логин</label>
      </div>

      <div class="field-wrapper">
        <input
          v-model="password"
          ref="inputPassword"
          type="password"
          placeholder="&nbsp;"
          spellcheck="false"
          autocomplete="off"
        />
        <label>Пароль</label>
      </div>

    
      <button
        :disabled="loadingAuth || !login || !password"
        @click="auth"
        type="submit"
      >
        Войти
      </button>
    </div>

  </div>
</template>

<script>

export default {
  data() {
    return {
      login: '',
      password: '',
      loadingAuth: false,
    };
  },

  methods: {
    async auth() {
      this.loadingAuth = true;
      const login = this.login;
      const password = this.password;

      try {
        const response = await this.$store.dispatch('adminlogin', {
          login,
          password,
        });

        if (response.data.success) {
          console.log('redirect')
          // console.log(response.data.token)
           
          this.$router.push(this.$route.query.next || '/dashboard');
        } else {
          this.showToaster(response.data.message);
        }

        this.loadingAuth = false;
      } catch (err) {
        console.log(err);
        this.showToaster('Неизвесная ошибка. Попробуйте еще раз');
      }
    },

    showToaster(msg) {
      this.$toast.show(msg, {
        position: 'top',
        // duration: false,
      });
    },
  },
};
</script>

<style scoped>
.main {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 15px;
  min-height: calc(100vh - 46px);
  padding: 15px;
}

.header {
  position: sticky !important;
  top: 0px !important;
}
</style>